module.exports = __webpack_public_path__ + "img/R_PLA_W.0b878191.svg";